<template>
  <div
    class="dropdown"
    :class="{ standalone }"
    @mouseleave="updateIndex(-1); mouseleave()"
    @mouseover="mouseover"
    ref="wrapper"
  >
    <div
      class="dropdown__item"
      v-for="(item, i) in items"
      :key="item.id || i"
      :class="{ 'dropdown__item--selected': arrValue.length > 0 && isSelected(item), 'dropdown__item--hover': i === index }"
      ref="items"
      @mouseover="updateIndex(i)"
      @click="selectItem(item)"
    >
      <div
        v-if="photoField"
        class="dropdown__item__image"
        :style="{ backgroundImage: `url(${item[photoField] || '/static/img/empty-states/logo.png'})` }"
      />
      <div class="dropdown__item__text">
        <p class="dropdown__item__text__title">{{ titleField ? item[titleField] : item }}</p>
        <p v-if="descField" class="dropdown__item__text__description">{{ getDescField(item) }}</p>
      </div>
    </div>
    <div
      v-if="create"
      class="dropdown__item"
      :class="{ 'dropdown__item--hover': items.length === index }"
      ref="createItem"
      @mouseover="updateIndex(items.length)"
      @click="$emit('create')"
    >
      <div class="dropdown__item__text">
        <p class="dropdown__item__text__title">{{ create }}</p>
      </div>
    </div>
    <div
      v-else-if="items.length <= 0"
      class="dropdown__item dropdown__item--empty"
    >No search results</div>
  </div>
</template>

<script>
export default {
  name: "DropdownList",
  props: {
    standalone: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => []
    },
    value: {
      type: [String, Object, Array],
      default: () => []
    },
    index: {
      type: Number,
      required: true
    },
    selectedKey: String,
    create: String,
    photoField: String,
    titleField: String,
    descField: String,
    noScroll: {
      type: Boolean,
      default: false
    },
    isPremise: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    arrValue() {
      if (Array.isArray(this.value)) {
        return this.value;
      }
      return [this.value];
    }
  },
  created() {
    window.addEventListener("mouseup", this.outsideBox);
  },
  mounted() {
    if (!this.noScroll) {
      this.updateDropdownScroll(this.index);
    }
  },
  beforeDestroy() {
    window.removeEventListener("mouseup", this.outsideBox);
  },
  methods: {
    isSelected(item) {
      return (
        this.arrValue.filter(v => {
          if (v !== null && this.selectedKey) {
            return v[this.selectedKey] === item[this.selectedKey];
          }
          return JSON.stringify(v) === JSON.stringify(item);
        }).length > 0
      );
    },
    outsideBox(e) {
      const { wrapper } = this.$refs;
      if (wrapper && e.target !== wrapper && !wrapper.contains(e.target)) {
        this.$emit("close", e);
      }
    },
    getHighlightedResult() {
      if (this.create && this.index === this.items.length) {
        this.$emit("create");
      } else if (this.index > -1 && this.index < this.items.length) {
        return this.items[this.index];
      }
      return null;
    },
    selectItem(item) {
      this.$emit("select", item);
    },
    updateDropdownScroll(index) {
      const { items } = this.$refs;
      if (items && index >= 0) {
        return false;
      }
    },
    mouseover() {
      this.$emit("mouseover", true);
    },
    mouseleave() {
      this.$emit("mouseover", false);
    },
    updateIndex(index) {
      if (this.index !== index) {
        this.$emit("update-index", index);
      }
    },
    getDescField(item) {
      if (this.isPremise) {
        if (item.description && item.description.length) {
          return item.address.short_address + " (" + item.description + ")";
        }
        return item.address.short_address;
      }
      return item[this.descField];
    }
  },
  watch: {
    index(newVal) {
      if (!this.noScroll) {
        this.updateDropdownScroll(newVal);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/style/_variables.scss";
.dropdown {
  display: block;
  width: 100%;
  max-height: 280px;
  overflow-y: scroll;
  z-index: 20;
  box-sizing: border-box;
  border: 1px solid $gray-dark;
  border-radius: $border-radius-md;

  &:not(.standalone) {
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    border-top: none;
  }

  &__item {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    padding: $padding-input-bottom $padding-input-left;
    box-sizing: border-box;
    background-color: $white;
    cursor: pointer;
    border-bottom: 1px solid $gray-dark;

    &:last-child {
      border-bottom: none;
    }

    &__image {
      width: 24px;
      height: 24px;
      border-radius: $border-radius-sm;
      border: 1px solid $blue-gray-active;
      flex-shrink: 0;
      background-color: $background-gray;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;

      & + .dropdown__item__text {
        padding-left: $padding-lg;
      }
    }

    &__text {
      display: flex;
      flex-direction: column;
      width: 100%;

      &__title {
        color: $label-gray;
        font-size: $font-size-md;
      }

      &__description {
        padding-top: 2px;
        color: $label-gray;
        font-size: $font-size-xs;
      }
    }

    &--selected {
      background-color: $blue-gray-light;
    }

    &--hover {
      background-color: $blue-navy;

      .dropdown__item__text {
        &__title,
        &__description {
          color: $white;
        }
      }
    }

    &--empty {
      font-size: $font-size-sm;
      color: $label-gray;
      cursor: default;
      text-align: center;
      padding-top: 40px;
      padding-bottom: 40px;
      justify-content: center;
    }
  }
}
</style>
